import { w as withConfigTransport } from "../../services/config-transport/withConfigTransport-31ef3979.mjs";
import { _ as _VaCard } from "./VaCard-33e24573.mjs";
import { V as VaCardContentBase } from "./components/va-card-content/VaCardContent-dd835113.mjs";
import { V as VaCardTitleBase } from "./components/va-card-title/VaCardTitle-ce0828e5.mjs";
import { V as VaCardActionsBase } from "./components/va-card-actions/VaCardActions-79ca634b.mjs";
import { V as VaCardBlockBase } from "./components/va-card-block/VaCardBlock-1bd093f1.mjs";
const VaCardContent = withConfigTransport(VaCardContentBase);
const VaCardTitle = withConfigTransport(VaCardTitleBase);
const VaCardActions = withConfigTransport(VaCardActionsBase);
const VaCardBlock = withConfigTransport(VaCardBlockBase);
const VaCard = withConfigTransport(_VaCard);
export {
  VaCardContent as V,
  VaCardTitle as a,
  VaCardActions as b,
  VaCardBlock as c,
  VaCard as d
};
//# sourceMappingURL=index-97add31d.mjs.map
